<div [class.print-only-display]="displayToPrintOnly" [class.print-both-display]="!displayToPrintOnly"
    class="p-paginator-bottom p-paginator p-component p-unselectable-text">
    Page {{ getCurrentPage() }} of {{ getTotalPageNumbers() }}
</div>